module.exports = __webpack_public_path__ + "840b84fe7829089f232b5f683ad67715.png";